import { useEffect } from 'react';
import { useLayoutSlots } from '@app/layouts/layoutContext';
import { useAppStore } from '@app/store/useAppStore';
import { useKey } from '@app/hooks/useKey';
import { KeyModeSelector } from '@components/KeyModeSelector';
import { ChordCard } from '@components/ChordCard';
import styles from './ChordsRoute.module.css';

export function ChordsRoute() {
  const { setCenter, setRight } = useLayoutSlots();
  const keyId = useAppStore((s) => s.selectedKeyId);
  const key = useKey(keyId);

  useEffect(() => {
    setCenter(
      <div className={styles.center}>
        <KeyModeSelector />
      </div>,
    );
    setRight(
      <div className={styles.list}>
        {key ? (
          key.diatonicChords.map((dc) => (
            <ChordCard
              key={dc.degree}
              chordId={dc.chordId}
              romanNumeral={dc.romanNumeral}
              chordFunction={dc.chordFunction}
            />
          ))
        ) : (
          <p className={styles.empty}>Pick a key on the Circle of Fifths.</p>
        )}
      </div>,
    );
    return () => {
      setCenter(null);
      setRight(null);
    };
  }, [key, setCenter, setRight]);

  return null;
}
